import React from "react";

import {
  type ITimeGranularityV2,
  TimeGranularityV2,
} from "@north-beam/nb-common";

import { type ExtendableSelectProps } from "./select";

import { Select } from ".";

interface Props extends ExtendableSelectProps {
  label?: string | React.ReactElement;
  className?: string;
  isLoading?: boolean;
  timeGranularity: ITimeGranularityV2;
  hideHourlyOption?: boolean;
  hiddenGranularities?: ITimeGranularityV2[];
  onChange: (obj: any) => void;
}

export const TimeGranularityV2Select = ({
  label,
  className,
  isLoading = false,
  timeGranularity,
  hiddenGranularities,
  hideHourlyOption = false,
  onChange,
  ...props
}: Props) => {
  const options = (
    hideHourlyOption
      ? TimeGranularityV2.reactSelectOptions.filter((e) => e.value !== "hourly")
      : TimeGranularityV2.reactSelectOptions
  ).filter((i) => !hiddenGranularities?.includes(i.value));

  return (
    <Select
      label={label ?? "TIME GRANULARITY"}
      className={className}
      isLoading={isLoading}
      value={TimeGranularityV2.toReactSelect(timeGranularity).value}
      options={options}
      icon={<i className="fa-regular fa-sharp fa-sitemap" />}
      onChange={onChange}
      {...props}
    />
  );
};
